import { StyledEllipsis } from './Ellipsis.styles'

const Ellipsis: React.FC = (): JSX.Element => {
    return <StyledEllipsis />
}

export default Ellipsis
